(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
  const sectionBanner = $(".banner-section").offset().top;
  $('.banner-item-content h2 p').each(function(){
    new SplitType($(this), { split: 'lines' });
  });
  $('.banner-item').each(function(){
    var duration = parseFloat(0.2);
    var textLine = $(this).find('.line');
    $.each(textLine, function(index, data){
        duration = duration + parseFloat(0.3);
        $(this).css('animation-delay', duration+'s');
    });
  });

  window.addEventListener('scroll', () => {
    let scrollTop = document.documentElement.scrollTop;
    document.querySelector('.image-desktop').style.transform = 'scale('+(100 + scrollTop/33)/100+')';
    // document.querySelector('.image-mobile').style.transform = 'scale('+(100 + scrollTop/33)/100+')';
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-text-marquee"] && !Shopify.designMode) return;
  try {
    

  function marquee(selector, speed) {
    const parentSelector = document.querySelector(selector);
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;

    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);

    function animateMarquee() {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
      requestAnimationFrame(animateMarquee);
    }
    animateMarquee();
  }

  window.addEventListener("load", () => marquee(".marquee", 2.5));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerWrapper.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    

  const sectionBanner = $(".banner").offset().top;
  const title = document.querySelector(".banner__box h2 p");
  let splitPerformed = false;  
  
  if (!splitPerformed) {
    new SplitType(title, { split: 'lines' });
    splitPerformed = true;
    var textLine = $('.banner__box').find('.line');
    var duration = parseFloat(0.5);
    $.each(textLine, function(index, data){
      duration = duration + parseFloat(0.3);
      $(this).css('animation-delay', duration+'s');
    });
  }

   window.addEventListener('scroll', () => {
    let scrollTop = document.documentElement.scrollTop;
    document.querySelector('.banner-inner').style.transform = 'scale('+(100 + scrollTop/33)/100+')';
    document.querySelector('.banner__media.hide-desktop').style.transform = 'scale('+(100 + scrollTop/33)/100+')';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    

  (function () {
    const sectionImgWithText = $(".image-with-text").offset().top;
    const imgbg = document.querySelector(".image-with-text .image-bg");
    const title = document.querySelector(".image-with-text h2");
    const button = document.querySelector(".image-with-text .button-more");
    const descriptionText = document.querySelector(".image-with-text .image-with-text__text p");
    const boxText = document.querySelector(".image-with-text .image-with-text__text-item");

    descriptionText.classList.add('js-split-text');

    let splitPerformed = false;

    window.addEventListener("scroll", function () {
      if (window.scrollY > sectionImgWithText - 700) {
        imgbg.style.transform = 'translateY(-100%)';
        boxText.style.opacity = '1';
      }
      if (!splitPerformed && window.scrollY >= sectionImgWithText - 700) {
        button.classList.add('active');
        new SplitType(title, { split: 'lines' });
        new SplitType(descriptionText, { split: 'lines' });
        splitPerformed = true;
        var textLine = $('.image-with-text__box-content').find('.line');
        var duration = parseFloat(0.5);
        $.each(textLine, function(index, data){
          duration = duration + parseFloat(0.3);
          $(this).css('animation-delay', duration+'s');
        });
      }
    });
  })();
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-metacine-define"] && !Shopify.designMode) return;
  try {
    

  gsap.registerPlugin(ScrollTrigger);

  $(".scaling-mask .metacine-content").length > 0 && ScrollTrigger.matchMedia({
    "(max-width: 1024px) and (min-width: 768px)": function() {
      gsap.timeline({
        scrollTrigger: {
          trigger: ".metacine-define",
          scrub: !0,
          start: "50px bottom",
          end: "bottom center"
        }
      }).fromTo(".scaling-mask .metacine-content", 1, {
        clipPath: "inset(0px 200px 0px 200px)"
      }, {
        clipPath: "inset(0px 0px 0px 0px)",
        ease: Power1.easeIn
      })
    },
    "(max-width: 767px)": function() {
      gsap.timeline({
        scrollTrigger: {
          trigger: ".metacine-define",
          scrub: !0,
          start: "50px bottom",
          end: "bottom center"
        }
      }).fromTo(".scaling-mask .metacine-content", 1, {
        clipPath: "inset(0px 120px 0px 120px)"
      }, {
        clipPath: "inset(0px 0px 0px 0px)",
        ease: Power1.easeIn
      })
    },
    "(min-width: 1025px)": function() {
      gsap.timeline({
        scrollTrigger: {
          trigger: ".metacine-define",
          scrub: !0,
          start: "50px bottom",
          end: "bottom center"
        }
      }).fromTo(".scaling-mask .metacine-content", 1, {
        clipPath: "inset(0px 300px 0px 300px)"
      }, {
        clipPath: "inset(0px 0px 0px 0px)",
        ease: Power1.easeIn
      })
    },
    "(min-width: 1440px)": function() {
      gsap.timeline({
        scrollTrigger: {
          trigger: ".metacine-define",
          scrub: !0,
          start: "50px bottom",
          end: "bottom center"
        }
      }).fromTo(".scaling-mask .metacine-content", 1, {
        clipPath: "inset(0px 400px 0px 400px)"
      }, {
        clipPath: "inset(0px 0px 0px 0px)",
        ease: Power1.easeIn
      })
    }
  });

  (function () {
    const sectionMetacineDefine = $(".metacine-define").offset().top;
    const title = document.querySelector(".metacine-define .content-before h2");
    const descriptionText = document.querySelector(".metacine-define .content-before p.split-text");
    const titleAfter = document.querySelector(".metacine-define .content-after h2");
    const descriptionTextAfter = document.querySelector(".metacine-define .content-after p.split-text");
    const boxText = document.querySelector(".metacine-define .scaling-mask");

    let splitPerformed = false;

    window.addEventListener("scroll", function () {
      if (!splitPerformed && window.scrollY >= sectionMetacineDefine - 500) {
        boxText.style.opacity = '1';
        new SplitType(title, { split: 'lines' });
        new SplitType(descriptionText, { split: 'lines' });
        new SplitType(titleAfter, { split: 'lines' });
        new SplitType(descriptionTextAfter, { split: 'lines' });
        splitPerformed = true;
        var textLine1 = $('.scaling-mask .content-before').find('.line');
        var textLine2 = $('.scaling-mask .content-after').find('.line');
        var duration1 = parseFloat(0.5);
        var duration2 = parseFloat(0.5);
        $.each(textLine1, function(index, data){
          duration1 = duration1 + parseFloat(0.3);
          $(this).css('animation-delay', duration1+'s');
        });
        
        $.each(textLine2, function(index, data){
          duration2 = duration2 + parseFloat(0.3);
          $(this).css('animation-delay', duration2+'s');
        });
      }
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-newsletter"]) return;
  try {
    
class newsletterDialog extends HTMLElement {
  constructor() {
    super();

    if (window.innerWidth > 767) {
      this.show(this);
    }
    this.querySelector('#close-popup').addEventListener('click', this.hide.bind(this));
    this.querySelector('#close-popup').addEventListener('click', this.dontShowPopUp.bind(this));

    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  } 
  show(container) {
    if (container != document.getElementById('newsletter-popup')) {
      document.getElementById('newsletter-popup').setAttribute('open', '');
      return
    }
    setTimeout(function() {
       if(getCookie('newsletterpopup') == 'nevershow'){
        document.getElementById('newsletter-popup').removeAttribute('open')
      } else {
        document.getElementById('newsletter-popup').setAttribute('open', '');
      }
    }, document.getElementById('newsletter-popup').getAttribute("data-delay"));
  }

  dontShowPopUp() {
    var d = new Date();
    var expire = this.getAttribute("data-expire")
    var time = expire* 24 * 60 * 60 * 1000;
    d.setTime(d.getTime() + time);
    var expires = "expires=" + d.toUTCString();
    document.cookie = 'newsletterpopup' + "=" + 'nevershow' + "; " + expires;
  }
  hide() {
    this.removeAttribute('open');
  }
}
customElements.define('newsletter-dialog', newsletterDialog)

  } catch(e) { console.error(e); }
})();
})();
